import { defineComponent as _defineComponent } from 'vue'
import GDragBlock from '@/components/common/g-drag-block.vue'
import store from '@/store'
import { Task, TaskStatus } from '@/store/modules/progressNotice'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-global-progress-notice-ball',
  setup(__props) {

const isShowDetail = ref(false)

// 点击之前的位置，如果不同则触发卡片样式变化
const afterPos = ref('')

const style = computed(() => {
  return isShowDetail.value
    ? {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: '#18a8c7',
        cursor: 'pointer',
      }
    : {
        width: '384px',
        height: 'fit-content',
        borderRadius: '4px',
        padding: '16px 24px',
      }
})

const taskStore = computed(() => store.state.progressNotice)

const totalPer = computed(() => {
  const total =
    taskStore.value?.taskList.reduce((pre, cur) => {
      return pre + cur.progress
    }, 0) ?? 0
  return total / (taskStore.value!.taskList.length || 1)
})

// 根据isShowTask和添加的任务中是否都是需要手动控制，来决定是否显示卡片
const isShowTask = computed(() => {
  return taskStore.value?.isShowTask && taskStore.value?.taskList.length
})

// 根据task状态设置样式
function taskStatusStyle(task: Task) {
  const { status, errorColor, successColor } = task
  if (status === TaskStatus.fulfilled) return { color: successColor }
  else if (status === TaskStatus.rejected) return { color: errorColor }
  else return {}
}
// 根据task状态设置文案
function taskStatusText(task: Task) {
  const { status, taskTitle, errorMsg, successMsg } = task
  if (status === TaskStatus.fulfilled) return successMsg
  else if (status === TaskStatus.rejected) return errorMsg
  else return taskTitle
}

// 关闭
function close() {
  taskStore.value!.isShowTask = false

  store.commit('progressNotice/clearTask')
}

function handleMouseDown({ e }: { e: MouseEvent }) {
  afterPos.value = String(e.clientX) + String(e.clientY)
}
function handleMouseUp({ e }: { e: MouseEvent }) {
  const pos = String(e.clientX) + String(e.clientY)
  if (pos !== afterPos.value) return
  // 卡片状态下只能点击关闭
  if (isShowDetail.value) {
    isShowDetail.value = !isShowDetail.value
  }
}

/** 动画 */
function beforeEnter(el: any) {
  el.style.opacity = 0
  el.style.paddingLeft = '100%'
}
function enter(el: any, done: any) {
  let delay = el.dataset.index * 80
  setTimeout(() => {
    el.style.transition = 'all .3s '
    el.style.opacity = 1
    el.style.paddingLeft = 0
    done()
  }, delay)
}

return { __sfc: true,isShowDetail, afterPos, style, taskStore, totalPer, isShowTask, taskStatusStyle, taskStatusText, close, handleMouseDown, handleMouseUp, beforeEnter, enter, GDragBlock }
}

})